import { useEffect, useState } from 'react';
import { useCart } from 'utils/cart-context';
import { onSelectItem } from 'utils/gtm';
import * as rudder from 'utils/rudderstack';

import type { ComponentsFunnelCartOffer } from 'queries/graphql';

import styles from './styles.module.scss';
import { type SalesFunnelData, useFunnelData } from 'utils/funnel-data-context';

export default function FunnelCartQuantitySelector({
  funnelOffer,
}: {
  funnelOffer: ComponentsFunnelCartOffer;
}) {
  const { offersConfig } = useFunnelData<SalesFunnelData>();
  const offer = offersConfig.find(
    _offer => _offer.id === funnelOffer.salesPageOffer.offer.hashedId
  );

  const offerId = offer?.id;
  const maxQuantity = offer?.maxQuantity;
  const { updateCartItem } = useCart();
  const [quantity, setQuantity] = useState(1);

  // If product changes, set to default 1
  useEffect(() => setQuantity(1), [funnelOffer]);

  const decrement = () => {
    if (!offerId) return;

    const newQuantity = quantity - 1;
    if (newQuantity < 1) return;
    updateCartItem({ offerId, quantity: newQuantity });
    setQuantity(newQuantity);
    onSelectItem({ ...offer, quantity: newQuantity });
    rudder.onSelectItem({ ...offer, quantity: newQuantity });
  };

  const increment = () => {
    if (!offerId) return;

    const newQuantity = quantity + 1;
    if (newQuantity > maxQuantity) return;
    updateCartItem({ offerId, quantity: newQuantity });
    setQuantity(newQuantity);
    onSelectItem({ ...offer, quantity: newQuantity });
    rudder.onSelectItem({ ...offer, quantity: newQuantity });
  };

  return (
    <div className={styles.main}>
      <h2 className={styles.heading}>Quantity</h2>
      <div className={styles.selector_wrapper}>
        <button className={styles.quantity_btn} onClick={decrement} disabled={quantity === 1}>
          &#8722;
        </button>
        <p className={styles.quantity}>{quantity}</p>
        <button
          className={styles.quantity_btn}
          onClick={increment}
          disabled={quantity === maxQuantity}
        >
          &#xFF0B;
        </button>
      </div>
    </div>
  );
}
